import { todayEndToUnix, todayStartToUnix } from 'utils';
export async function loadDataFromServer(api, device_ids, mintime = todayStartToUnix(), maxtime = todayEndToUnix(), data_types = ['gps', 'events'], request_options = {}) {
    try {
        const request_results = await api.load_data(device_ids.map((device_id) => ({
            device_id,
            mintime,
            maxtime,
            data_types,
            request_options,
        })));
        return Object.fromEntries(request_results.responses.map((response) => [
            response.device_id,
            response,
        ]));
    }
    catch (error) {
        return Promise.reject(error);
    }
}
